<template>
    <div>
        <div
            v-for="(item, index) in items"
            :key="index"
            class="wrapper flex cursor-pointer select-none my-2"
            @click="handleClick(item.value)"
        >

            <div
                :class="{ 'bg-primary border-transparent' : selected(item.value) }"
                class="wrapper__checkbox"
            >
                <span v-show="selected(item.value)">&check;</span>
            </div>
            <span
                v-if="item.label"
                class="ml-3 text-sm"
            >{{ item.label }}</span>

        </div>
    </div>
</template>

<script>
export default {

    props: {
        items: {
            type: Array,
            required: true,
        },
        value: {
            type: Array,
            required: true,
        },
    },

    methods: {
        handleClick(value) {
            if (this.selected(value)) {
                this.value = this.value.filter((e) => e !== value);
            } else {
                this.value.push(value);
            }
            this.$emit('input', this.value);
        },
        selected(value) {
            return this.value.includes(value);
        },
    },

};
</script>

<style lang="scss" scoped>
.wrapper {
    @apply transition-fast;
    &__checkbox {
        @apply rounded h-5 w-5 flex justify-center items-center leading-none text-white font-bold border border-primary ;
        border-width: 2px;
    }

    &:hover {
        @apply opacity-75;
    }
}
</style>
